import { api } from '../config'
import { Coupon } from '../../redux/Events/types'
import { AxiosResponse } from 'axios'

type RequestBody = {
  name: string
  description: string
  amountOfUse: number
  value: string | number
  valueType: 'PERCENT' | 'CENTS'
  quantity?: number
  startValidateDate?: string
  finalValidateDate?: string
}

export const createCouponService = async (
  eventId: string,
  requestBody: RequestBody
) => {
  console.log(typeof requestBody.value)
  const { data }: AxiosResponse<Coupon> = await api.post(
    `/api/coupons/events/${eventId}`,
    {
      ...requestBody,
      value:
        typeof requestBody.value === 'number'
          ? requestBody.value
          : Number(requestBody.value.replace(/[^\d]/g, ''))
    }
  )

  return data
}
